
import * as types from '../types';
/**
 *
 * @param instance
 */
export const hydrateData = (instance) => {
    const container = instance.$parent.$el;
    const { collection,hostname } = container.dataset;
    if(collection){
        instance.collection = JSON.parse(collection);
        instance.hostname = hostname;
        instance.$store.dispatch(types.SET_HOSTNAME, hostname);
        instance.$http.options.root = hostname;
    }
};


/**
 *
 * @param collectionProductFilter
 * @param collectionProduct
 * @returns {*}
 */
export const getTarget = ({collectionProductFilter, collectionProduct}) => {
    if (!collectionProductFilter) {
        return collectionProduct;
    }
    return collectionProductFilter;
}

/**
 *
 * @param state
 * @returns {{}}
 */
export const getAssociations = (state) => {
    const {associations} = getTarget(state);
    return associations ? associations : {};
};

/**
 *
 * @param product_option_values
 * @param product_feature_values
 * @returns {*}
 */
export const getFilterValuesFromResponse = ({product_option_values, product_feature_values}) => {

    if (!product_option_values) {
        return product_feature_values;
    }
    return product_option_values;
};

/**
 *
 * @param id_attribute
 * @param id_feature_value
 * @returns {number}
 */
export const getIdFromFilterType = ({id_attribute, id_feature_value}) => {
    if (!id_attribute) {
        return parseInt(id_feature_value);
    }
    return parseInt(id_attribute);
};


/**
 *
 * @param product
 * @returns {*}
 */
export const getIdFromProduct = (product) =>{
    let {id} = product;
    if (!id) {
        id = product;
    }

    return id;
};



// WEBPACK FOOTER //
// ./src/store/helper/index.js